// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3V2hO","inner":"Footer_inner__55uHJ"};